module.exports = __webpack_public_path__ + "static/img/rule_txt.3c3c930.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rule_txt.png
// module id = 570
// module chunks = 1